<template>
	<div class="auth-box">
		<div class='flex_center'>
			<div class="line-div"></div>
			<div class="f-s-18">账号授权</div>
		</div>
		<div class='flex_center p-t-20'>
			<img class="phone-img" src="../../assets/phone.png" />
			<div class="f-s-18 w-500 somber">{{xgUserInfo.mobile|mobile|mobile}}</div>
		</div>
		<div class="p-t-10 gray f-s-18 t-c">
			需要授权获取您的移动积分
		</div>
		<div class="flex_center">
			<van-checkbox v-model="agree" icon-size="40px">
				<span class="f-s-12">同意</span>
				<span class="blue f-s-12" @click="toUserAggerment">《畅由用户协议》</span>
			</van-checkbox>
		</div>
		<div class="auto-div t-c p-t-20">
			<van-button type="primary" :disabled="!agree" @click="toAuth">确认授权</van-button>
		</div>
	</div>
</template>


<script>
	import { Toast } from 'vant';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	import { getPkParamStr } from '@/request/api';
	export default {
		name: 'Auth',
		computed: mapGetters(['xgUserInfo']),
		data() {
			return {
				agree: true,
				// callbackUrl:'http://192.168.0.109:8080#/home',
				callbackUrl:'https://jf.ydong.com.cn#/home',
				// baseUrl:'https://test-m-stg1.ppppoints.com/event/2019/blankPage/index.html?',
				baseUrl:'https://m.changyoyo.com/event/2019/blankPage/index.html?',
				authUrl:'',
				agreementUrl:'https://m.changyoyo.com/my/account/agreement.html?spm=3.1.102784.0.0.939391628662541391.02011685.02011685'
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			init(){
				getPkParamStr({
					callbackUrl:this.callbackUrl
				}).then(res => {
					this.authUrl = this.baseUrl+res
					this.firstAuth()
				}) 
			},
			firstAuth(){
				let uri = window.location.href.split("#")[0]
				if(!uri.includes('resultCode')){
					this.toAuth()
				}
			},
			toAuth(){
				 window.location = this.authUrl
			},
			toUserAggerment(){
				window.location = this.agreementUrl
			}
			
			
		}
	}
</script>

<style scoped>
	.auth-box {
		width: 300px;
		height: max-content;
		padding: 30px 20px;
	}

	.line-div {
		width: 5px;
		height: 20px;
		margin-right: 5px;
		background-color: #ee7693;
	}

	.phone-img {
		width: 30px;
		height: 30px;
	}

	.auto-div /deep/ .van-button--normal {
		background-color: #ec616c;
		border-color: #ec616c;
		width: 250px;
		border-radius: 5px;
	}
</style>
